import { convertRateToMonthlyNumber } from './convertRateToMonthly';

const hasAmountAndFrequency = income =>
  income?.amount !== undefined && income.amount !== null && income.amount !== '' && Boolean(income?.frequency);

/**
 * Converts the income values captured on the employment step to the monthly
 * value required by the expense comparison banner.  An absent income remains
 * `null` so consumers do not mistake an incomplete application for $0 income.
 */
export function getMonthlyIncome(employmentDetails = {}) {
  const hasPrimaryIncome = hasAmountAndFrequency(employmentDetails.income);
  const hasAdditionalIncome =
    employmentDetails.hasOtherIncome === 'yes' && hasAmountAndFrequency(employmentDetails.otherIncome);

  if (!hasPrimaryIncome && !hasAdditionalIncome) {
    return null;
  }

  return (
    (hasPrimaryIncome ? convertRateToMonthlyNumber(employmentDetails.income) : 0) +
    (hasAdditionalIncome ? convertRateToMonthlyNumber(employmentDetails.otherIncome) : 0)
  );
}
